import { APIS } from '../constants/apis';
import axiosInstance from '../utils/axios';

export async function getRedemptionShopCode(code: string) {
  const respone = await axiosInstance
    .get(APIS.getRedemptionShop + '/' + code)
    .then(function (response) {
      return response;
    })
    .catch(function (response) {
      return response;
    });
  return respone;
}
export async function getRedemptionShopCodeVerify(code: string) {
  const respone = await axiosInstance
    .post(APIS.getRedemptionShop + '/' + code + '/verify')
    .then(function (response) {
      return response;
    })
    .catch(function (response) {
      return response;
    });
  return respone;
}
